import React, { PureComponent } from "react";
import "./Graph.css";
import Distribution from "./Distribution.js";
import Timeline from "./Timeline.js";

export default class Graph extends PureComponent {
  render() {
    return (
      <div className="graph">
        <div className="graph-heading">{this.props.name}</div>
        {this.props.type === "distribution" ? <Distribution /> : <Timeline />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Graph.js